import _ from 'lodash';

export const textEllipse = (name, maxchar) => {
  if (!name || _.isNumber(name) || name.length < maxchar) {
    return name;
  }
  return `${name.toString().substring(0, maxchar)}...`;
};

export const textWrap = (label, maxCharactersPerLine) => {
  // Check for empty label, numeric label, or label shorter than maxCharactersPerLine
  if (!label || _.isNumber(label) || label.length < maxCharactersPerLine) {
    return label;
  }

  // Split the label into an array of words
  const words = label.split(' ');
  const lines = []; // Array to hold lines of text
  let currentLine = ''; // Current line being constructed

  words.forEach((word) => {
    if (word.length > maxCharactersPerLine) {
      // Handle long words by breaking them with a hyphen
      const slicedWord = `${word.slice(0, maxCharactersPerLine - 1) }-`;
      lines.push(slicedWord); // Add sliced word to lines
      currentLine = '';

      let remaining = word.slice(maxCharactersPerLine - 1);
      // Continue splitting remaining characters into lines with hyphens
      while (remaining.length > maxCharactersPerLine) {
        lines.push(`${remaining.slice(0, maxCharactersPerLine - 1) }-`);
        remaining = remaining.slice(maxCharactersPerLine - 1);
      }

      if (remaining) {
        currentLine = `${remaining } `;
      }
    } else if (currentLine.length + word.length + 1 <= maxCharactersPerLine) {
      // Add word to the current line if it fits
      currentLine += `${word} `;
    } else {
      // Push the current line to the lines array and start a new line
      lines.push(currentLine.trim());
      currentLine = `${word} `;
    }
  });

  if (currentLine.trim() !== '') {
    // Add the last line to the lines array if not empty
    lines.push(currentLine.trim());
  }

  return lines; // Return the array of wrapped lines
};
